import { createFileRoute } from '@tanstack/react-router';

import { OrderForm } from '../components/OrderForm';

export const Route = createFileRoute('/')({
  component: OrderForm,
});
